<template>
  <div class="loyalty-program">
    <section class="heading-section">
      <div class="page-container">
        <div class="heading-section__titles">
          <h2 class="heading-section__subtitle">
            {{ $t('loyalty.heading.subtitle') }} <img src="/img/svgo/dnipro-M-logo-black.svg" alt="logo"> {{ $t('loyalty.itis') }}
          </h2>
          <h1 class="heading-section__title">
            <Typewriter
              :words="headingTypewriterWords"
              :speed="20"
              :erase-delay="2000"
              :cursor="false"
            />
          </h1>
        </div>
        <div class="heading-section__img-wrap">
          <div class="heading-section__img"></div>
        </div>
        <div class="heading-section__auth">
          <LoyaltyProgramAuth class="loyalty-auth loyalty-auth--heading"/>
        </div>
      </div>
    </section>
    <slot v-bind:language="language"></slot>
    <section class="section-prefooter" v-if="!isUserAuth">
      <div class="page-container">
        <div class="section-row">
          <div class="section-col section-col--left">
            <p class="loyalty__title">
              {{ $t('loyalty.prefooter.title') }} <img src="/img/svgo/dnipro-M-logo.svg" alt="logo">
            </p>
            <div class="section-prefooter__agreement">
              {{ $t('auth_agreement_text') }} <a :href="urlLanguagePrefix + '/terms-and-conditions/'" target="_blank">{{
                $t('auth_agreement_link') }}</a>
            </div>
            <LoyaltyProgramAuth class="loyalty-auth loyalty-auth--prefooter"/>
          </div>
          <div class="section-col--right">
            <div class="section-prefooter__text">
              {{
                $t('loyalty.prefooter.text')
              }}
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import LoyaltyProgramAuth from '@/views/landings/loyalty-program/LoyaltyProgramAuth'
import Typewriter from '@/components/promo-pages/Typewriter'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'LoyaltyProgram',
  components: {
    LoyaltyProgramAuth,
    Typewriter
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix']),
    ...mapState({
      language: state => state.translation.language,
      isUserAuth: state => state.user.auth
    }),
    headingTypewriterWords () {
      return [
        this.$t('loyalty.heading.title'),
        this.$t('loyalty.heading.title2'),
        this.$t('loyalty.heading.title3')
      ]
    }
  }
}
</script>
<style scoped lang="sass">
.heading-section
  display: flex
  align-items: center
  padding: 0 0 45px 0
  overflow-x: hidden
  +mmin($tablet)
    padding: 100px 0
  +mmin($large--mid)
    padding: 150px 0

.heading-section__titles
  +mmin($small--hor)
    max-width: 60%
  +mmin($large--ext)
    max-width: 80%

.heading-section__title
  font-size: 24px
  text-transform: uppercase
  color: $text-color
  line-height: 1.25
  font-weight: 500
  margin: 20px 0 0
  height: 2em
  +mmin($tablet)
    margin: 35px 0
    font-size: 60px
    line-height: 1.15

.heading-section__subtitle
  font-size: 16px
  color: $text-color
  text-transform: uppercase
  line-height: 1.5
  font-weight: 500
  +mmin($tablet)
    font-size: 22px
    line-height: 1.27
  img
    height: 1.1em
    vertical-align: middle

.heading-section__img
  background-image: url('/img/loyalty-program/bonus-icon-3d.png')
  background-repeat: no-repeat
  background-size: contain
  background-position: center
  width: 100%
  padding-top: 90%
  position: relative
  &::before, &::after
    content: ''
    position: absolute
    border-radius: 50%
    border: 1px solid #FF2F00
    z-index: -1
  &::before
    width: 55vw
    height: 55vw
    left: -10%
    top: 13%
  &::after
    width: 70vw
    height: 70vw
    left: 55%
    top: 14%
  +mmin($small--hor)
    &-wrap
      right: 0
      top: 200px
      width: 825px
      max-width: 50%
      position: absolute
      z-index: -1
    &:before
      width: 485px
      height: 465px
      left: 15%
      top: -20%
    &:after
      width: 607px
      height: 581px
      left: 55%
      top: -5%

.section-prefooter
  padding: 60px 0
  color: #fff
  background: linear-gradient(177.09deg, rgba(31, 31, 32, 0) 22.75%, #1F1F20 97.58%), linear-gradient(0deg, rgba(51, 51, 51, 0.5), rgba(51, 51, 51, 0.5)), url('/img/loyalty-program/section-prefooter__bg--mob.jpg')
  background-position: top
  background-size: 100% auto
  background-repeat: no-repeat
  background-color: #1F1F20
  +mmin($tablet)
    padding: 100px 0
    background: linear-gradient(177.09deg, rgba(31, 31, 32, 0) 22.75%, #1F1F20 97.58%), linear-gradient(0deg, rgba(51, 51, 51, 0.5), rgba(51, 51, 51, 0.5)), url('/img/loyalty-program/section-prefooter__bg.jpg')
    background-position: bottom center
    background-size: cover

  .loyalty__title
    color: #fff
    img
      height: 1.1em
      vertical-align: middle

.section-prefooter .section-row
  justify-content: space-between
  +mmax($tablet - 1)
    flex-direction: column
    .section-col--left
      width: 100%
      flex: 0 0 auto
      max-width: 500px

.section-prefooter__agreement
  color: rgba(231, 231, 231, 0.6)
  font-size: 14px
  +mmin($tablet)
    margin-top: 30px
  a
    color: #5895CC

.section-prefooter__text
  font-size: 14px
  line-height: 1.5
  +mmin($tablet)
    font-size: 18px

.loyalty-auth
  max-width: 700px

.loyalty-auth--heading
  +mmin($tablet)
    margin-top: 125px

.loyalty-auth--prefooter
  margin: 35px 0 45px 0
  ::v-deep
    .auth-title
      color: #fff
    +mmin($tablet)
      .form-label
        color: #e7e7e7
  +mmin($tablet)
    margin: 70px 0

</style>
